<template>

	<div class="items-container">
		<!-- Subtotal -->
		<div>
			<span>
				{{ __('subtotal') }}
			</span>
			<span>
				{{ subtotal }} {{ $page.props.store.currency_symbol || $page.props.store.currency_code }}
			</span>
		</div>

		<div v-if="showVat">
			<span>
				{{ __('vat') }}
			</span>
			<span>
				{{ $store.state.cart.vat?.toFixed(2) || 0 }} {{ $page.props.store.currency_symbol ||
					$page.props.store.currency_code }}
			</span>
		</div>

		<!-- Discount -->
		<div v-if="$store.state.cart.authenticated_user_discount">
			<span>
				{{ __('client_discount') }} (5%)
			</span>
			<span>
				-{{ $store.state.cart.authenticated_user_discount.toFixed(2) }} {{ $page.props.store.currency_symbol ||
					$page.props.store.currency_code }}
			</span>
		</div>

		<!-- Voucher -->
		<div v-if="$store.state.cart.voucher !== null" class="bg-light-grey p-3 rounded mb-2 d-flex flex-column gap-2">
			<div class="d-flex justify-content-between align-items-center w-100">
				<div>
					<span class="text-muted">
						{{ __('voucher') }}
					</span>
					<div class="h4 mb-1 d-flex items-center gap-2">
						<span>{{ $store.state.cart.voucher.code }}</span>
						<div class="text-success fw-bold">
							{{ $store.getters['cart/voucherDetail'] }}
						</div>
					</div>
				</div>
				<button class="btn btn-sm btn-link text-danger" @click="$store.dispatch('cart/removeVoucher')">
					<i class="lnr icon-trash"></i> {{ __('remove_voucher') }}
				</button>
			</div>
			<div class="small text-muted" v-html="$store.state.cart.voucher.description"></div>
		</div>

		<!-- Shipping -->
		<div v-if="showShipping">
			<span>
				{{ __('shipping.title') }}
			</span>
			<span>
				{{ $store.state.cart.shipping_price.toFixed(2) }} {{ $page.props.store.currency_symbol ||
					$page.props.store.currency_code }}
			</span>
		</div>

		<!-- Free shipping message -->
		<FreeShippingMessage v-if="$store.state.cart.shipping_price" />

		<!-- Payment Method Price -->
		<div v-if="$store.state.cart.payment_method_price">
			<span>
				{{ __('payment_method.price') }}
			</span>
			<span>
				{{ $store.state.cart.payment_method_price.toFixed(2) }} {{ $page.props.store.currency_symbol ||
					$page.props.store.currency_code }}
			</span>
		</div>

		<!-- Grand Total -->
		<div>
			<span>
				{{ __('grand_total') }}
			</span>
			<span>
				{{ $store.state.cart.grand_total.toFixed(2) }} {{ $page.props.store.currency_symbol ||
					$page.props.store.currency_code }}
			</span>
		</div>
	</div>

</template>

<script>

import FreeShippingMessage from "@/Components/ECart/FreeShippingMessage.vue";
import { store as storeConfig } from "~app_root/public/tv/app.config";

export default {
	name: "CartStats",

	data: function () {
		return {
			showVat: storeConfig.checkout_show_vat,
		}
	},

	props: {
		'hideShippingIfZero': {
			type: Boolean,
			default: false
		}
	},

	components: {
		FreeShippingMessage
	},

	computed: {

		showShipping: function () {

			// Hide shipping automatically if store config says so
			if (storeConfig.checkout_hide_shipping) {
				return false;
			}

			return this.hideShippingIfZero ? this.$store.state.cart.shipping_price > 0 : true;
		},

		subtotal: function () {
			return storeConfig.checkout_show_vat ? (this.$store.state.cart.subtotal - this.$store.state.cart.vat).toFixed(2) : this.$store.state.cart.subtotal.toFixed(2);
		},

	}

}
</script>